import {
  Colors,
  GradientNames,
  IconNames,
} from '@cinch-labs/design-system/dist/src/tokens/tokens.types'
import cx from 'classnames'
import styles from './section-with-image-v2.module.css'
import Image from 'next/legacy/image'
import { Secondary, SvgIcon, Text } from '@cinch-labs/design-system'
import { StoryblokImage } from '@cinch-nx/data-storyblok'

interface StoryblokImageBlock {
  image: StoryblokImage
}

export interface SectionWithImageV2Props {
  image: StoryblokImageBlock[]
  heading: string
  text: string
  buttonLabel: string
  onButtonClick?: () => void
  iconName?: keyof typeof IconNames
  iconColor?: Colors
  headingColor?: Colors
  iconGradient?: keyof typeof GradientNames
  backgroundColor?: string
  customClassNames?: {
    heading?: string
    text?: string
    button?: string
    icon?: string
  }
}

export const SectionWithImageV2: React.FC<SectionWithImageV2Props> = ({
  image,
  onButtonClick,
  heading,
  text,
  buttonLabel,
  iconName = 'arrows-left-right',
  iconColor,
  headingColor,
  iconGradient,
  backgroundColor = '#5234B6',
  customClassNames,
}) => {
  const textClassNames = cx(styles.text, customClassNames?.text)
  const headingClassNames = cx(styles.heading, customClassNames?.heading)
  const buttonClassNames = cx(styles.button, customClassNames?.button)
  const iconClassNames = cx(styles.icon, customClassNames?.icon)
  const imageElement = image?.[0]?.image

  return (
    <section className={styles.container} style={{ backgroundColor }}>
      <div className={styles.inner}>
        <div className={styles.contentContainer}>
          <SvgIcon
            name={iconName}
            color={iconColor ? iconColor : undefined}
            gradient={iconGradient ? iconGradient : undefined}
            className={iconClassNames}
          />
          <Text
            className={headingClassNames}
            style={{ color: headingColor ?? '#8dffbe' }}
          >
            {heading}
          </Text>
          <Text className={textClassNames}>{text}</Text>
          <Secondary
            variant="alternative"
            classNames={{ button: buttonClassNames }}
            onClick={onButtonClick}
          >
            {buttonLabel}
          </Secondary>
        </div>
        <div className={styles.imageContainer}>
          {imageElement?.filename && (
            <Image
              src={imageElement.filename}
              className={styles.image}
              alt={imageElement.alt ?? undefined}
              layout="fill"
              objectFit="cover"
              quality={100}
            />
          )}
        </div>
      </div>
    </section>
  )
}
